import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { RouterModule } from '@angular/router';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

import { ScreenListingItemComponent } from './components/screen-listing-item/screen-listing-item.component';
import { ListingItemComponent } from './components/listing-item/listing-item.component';
import { FavouriteScreenModalComponent } from './components/favourite-screen-modal/favourite-screen-modal.component';
import { UiModule } from '@monorepo/ui';

@NgModule({
  declarations: [
    ScreenListingItemComponent,
    ListingItemComponent,
    FavouriteScreenModalComponent,
  ],
  imports: [
    CommonModule,
    SwiperModule,
    RouterModule,
    FomanticUIModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    UiModule,
  ],
  exports: [ScreenListingItemComponent, ListingItemComponent],
})
export class ScreenListingItemModule {}
